<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>
                                Banner settings
                            </h2>
                        </div>
                        <div class="col-md-6 text-right">
                            <a :href="$laravelRoute('manage')">Back To Admin Panel</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit">
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-md-12 container-search">
                                <div class="form-row">
                                    <b-form-group class="col-md-6"
                                                  label="Text"
                                                  label-for="text"
                                                  :state="fieldState('name')"
                                                  :invalid-feedback="invalidField('name')"
                                    >
                                        <b-form-input
                                            required
                                            ref="name_input"
                                            id="text"
                                            type="text"
                                            v-model="setting.value.text"
                                            :state="fieldState('name')"
                                            placeholder="Enter text">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-3"
                                                  label="Color"
                                                  label-for="color"
                                                  :state="fieldState('currency_code')"
                                                  :invalid-feedback="invalidField('currency_code')">
                                        <b-form-select
                                            id="color"
                                            class="form-control"
                                            v-model="setting.value.background"
                                        >
                                            <option :value="color.code" v-for="color in colors">
                                                {{ color.name }}
                                            </option>
                                        </b-form-select>

                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-2"
                                                  label="Enabled"
                                                  label-for="enabled"
                                                  :state="fieldState('enabled')"
                                                  :invalid-feedback="invalidField('enabled')">
                                        <b-form-checkbox
                                            id="enabled"
                                            v-model="setting.enabled"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>

                                <div class="form-row mt-2">
                                    <div class="form-group col-md-6">
                                        <b-btn type="submit" class="btn">Save</b-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BootstrapValidation from '../../mixins/bootstrap-validation';
import api from '../../api/api_resource'

export default {
    name: "AuctionAlertBanner",
    mixins: [BootstrapValidation],
    props: {
        settingData: {
            type: [Object, null],
            default: null
        }
    },
    data() {
        return {
            messages: [],
            colors: [
                {name: 'Blue', code: '#007bff'},
                {name: 'Red', code: '#D0342C'}
            ],
            setting: {
                name: 'auction_alert_banner',
                value: {
                    text: '',
                    background: '#007bff'
                },
                enabled: true,
            },
        }
    },

    mounted() {
        if (this.settingData !== null) {
            this.setting = this.settingData
        }
    },

    methods: {
        onSubmit() {
            this.messages = []
            api.post('admin.site-settings.save', [], this.setting)
                .then(response => {
                    if (response && response.message) {
                        this.messages.push({type: 'success', message: response.message});
                    }
                }).catch(error => {
                this.messages.push({type: 'danger', message: error.message});
                this.errors = error.errors;

            });
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/SiteSettings/AuctionAlertBanner.vue